export const isGatsbyImage = image => {
  return typeof image !== 'string' && !!image && (!!image.fixed || !!image.fluid);
};
